import { render, staticRenderFns } from "./addBusinessDatabus.vue?vue&type=template&id=54478558"
import script from "./addBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./addBusinessDatabus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports